import { render, staticRenderFns } from "./CursoNuevo.vue?vue&type=template&id=3ecc7828&"
import script from "./CursoNuevo.vue?vue&type=script&lang=js&"
export * from "./CursoNuevo.vue?vue&type=script&lang=js&"
import style0 from "./CursoNuevo.vue?vue&type=style&index=0&id=3ecc7828&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports